<template lang="pug">
  .modal.is-active(key="modal-editar")

    .modal-background(@click="closeModalAdd()")
    .card
      header.modal-card-head.display-flex
        p.flex-1
          span(v-if="id") Editar link importante
          span(v-else) Crear link importante
        span.icon.close(
            @click="$emit('close')"
          )
            i.fa.fa-close
      .card-content
        .title

          .display-flex
            .control.margin-bottom-10.flex-1
              p.margin-bottom-5 Orden
              input.input.w-90(
                type="number",
                v-model="orden"
                :disabled="isLoading"
              )

            .control.margin-bottom-10.text-center
              p.margin-bottom-5 Activo
              input.checkbox(
                type="checkbox",
                v-model="activo"
                :disabled="isLoading"
              )

          .control.margin-bottom-10
            p.margin-bottom-5 Descripcion
            input.input.w-300(
              type="text",
              v-model="descripcion"
              :disabled="isLoading"
            )

          .control.margin-bottom-10
            p.margin-bottom-5 Ruta
            input.input.w-300(
              type="text",
              v-model="ruta"
              :disabled="isLoading"
            )

      footer.card-footer
        a.card-footer-item.is-success(@click="guardar")
          span(v-if="isSaving") Guardando...
          span(v-else) Guardar
        a.card-footer-item( @click="$emit('close')")
          strong Cancelar

</template>

<script>
import { apiGet, apiPost, notify } from '../util/general'
export default {
  name: 'c_gestion_links_importantes_editar',
  props: ['id'],
  data () {
    return {
      orden                : 100,
      descripcion          : '',
      activo               : true,
      ruta                 : '',
      isSaving             : false,
      isLoading            : false
    }
  },
  mounted () {
    var vm = this
    if (vm.id) {
      vm.fetch()
    }
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {
        id: vm.id
      }

      apiGet(vm, '/links-importantes/' + vm.id, obj, function (data) {
        vm.orden       = data.data.orden
        vm.descripcion = data.data.descripcion
        vm.activo      = data.data.activo
        vm.ruta        = data.data.ruta
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    guardar () {
      var vm = this

      if (vm.isSaving) return;

      vm.isSaving = true

      var obj = {
        orden       : vm.orden,
        descripcion : vm.descripcion,
        activo      : vm.activo,
        ruta        : vm.ruta
      }

      if (vm.id) {
        obj.id        = vm.id
      }

      apiPost(vm, '/links-importantes', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        vm.$emit('closeRefresh')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    },
    emitClose () {
      this.$emit('close')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .solicitud-vacaciones
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
      .little
        font-size 14px

  .contenedor-datos
    display flex
    justify-content center
    >*
      transition: all 0.5s;

    .contenedor-transaccion
      .fechas
        display flex
        justify-content center
        .control
          padding 10px

      .acciones
        display flex
        margin-top 10px
        .button
          flex 1
          margin 5px

  .indicaciones
    flex 1
    padding 10px
    border 1px solid #209cee
    color: #12537e;
    background-color #f6fbfe
    display flex
    flex-direction column
    margin 10px
    max-width: 426px;

    strong
      color #209cee

    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 21px
      margin-bottom 5px

    .list
      display flex
      flex-direction column
      justify-content center
      flex 1
      text-align left
      .list-item
        padding-left 10px

  .codigo-empleado
    position relative
    .control
      text-align center
      .input
        width 100px

  .pop-over
      background: #fff;
      border-radius: 3px;
      border: 1px solid #d6dadc;
      border-bottom-color: #c4c9cc;
      -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
      box-shadow: 0 1px 6px rgba(0,0,0,.15);
      position: absolute;
      width: 300px;
      z-index: 70;
      top 0
      left: 42px;
</style>



// WEBPACK FOOTER //
// c_gestion_links_importantes_editar.vue?616f8ec2